import type {ReviewTicketSerializer} from "@/generated/DjangoTypes";
import {useGenericInfiniteQueryWithCount} from "@/hooks/useQueryHooks";
import {client} from "@/httpClient";
import {queryClient} from "@/queryClient";
import {useMutation} from "@tanstack/react-query";

const BASE = "/review_tickets/tickets/";

export const REVIEW_TICKET_KEYS = {
  mDismissTicket: (id: number) => [`${BASE}${id}/dismiss/`],
  mReopenTicket: (id: number) => [`${BASE}${id}/reopen/`],
  qTicketList: (params?: string) => [`${BASE}?${params ?? ""}`],
};

export const invalidateTickets = () =>
  queryClient.invalidateQueries({
    predicate: query => typeof query.queryKey[0] === "string" && (query.queryKey[0] as string).startsWith(BASE),
  });

export const useReviewTicketsQuery = (params?: string) =>
  useGenericInfiniteQueryWithCount<ReviewTicketSerializer>({
    queryKey: REVIEW_TICKET_KEYS.qTicketList(params),
  });

export const useDismissTicketMutation = () =>
  useMutation({
    meta: {skipSuccessToast: true},
    mutationFn: ({id}: {id: number}) => client.post(REVIEW_TICKET_KEYS.mDismissTicket(id)[0], {}),
    onSuccess: invalidateTickets,
  });

export const useReopenTicketMutation = () =>
  useMutation({
    meta: {skipSuccessToast: true},
    mutationFn: ({id}: {id: number}) => client.post(REVIEW_TICKET_KEYS.mReopenTicket(id)[0], {}),
    onSuccess: invalidateTickets,
  });
